<template>
  <div>
    <sweet-modal ref="modal" width="40vw">

      <sweet-modal-tab :title="$t('ct-tags-builderall-text')" id="ct-tags-builderall-text">
        <div class="row">
          <div class="col-6">
            <div v-for="(element,index) in tagList" v-if="index % 2 === 0" :key="index"
                 :class="['item-tag show ' + element]" :data-name="element">
              <div @click="focusTag(element)" :value="element">{{$t('ct-'+element.replace(/_/gi,'-'))}}</div>
            </div>
          </div>
          <div class="col-6">
            <div v-for="(element,index) in tagList" v-if="index % 2 === 1" :key="index"
                 :class="['item-tag show ' + element]" :data-name="element">
              <div @click="focusTag(element)" :value="element">{{$t('ct-'+element.replace(/_/gi,'-'))}}</div>
            </div>
          </div>
        </div>
      </sweet-modal-tab>
      <sweet-modal-tab :title="$t('ct-smart-tags')" id="ct-smart-tags">
        <div class="row">
          <div class="col-6">
            <div v-for="(element,index) in tags" v-if="index % 2 === 0" :key="index"
                 :class="['item-tag show ' + element.name.replace('[','').replace(']','')]" :data-name="element.name">
              <div @click="focusTag(element.name)" :value="element.name">{{element.name}}</div>
            </div>
          </div>
          <div class="col-6">
            <div v-for="(element,index) in tags" v-if="index % 2 === 1" :key="index"
                 :class="['item-tag show ' + element.name.replace('[','').replace(']','')]" :data-name="element.name">
              <div @click="focusTag(element.name)" :value="element.name">{{element.name}}</div>
            </div>
          </div>
        </div>
      </sweet-modal-tab>

      <button slot="button" class="btn btn-outline-light" @click="close">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="save">{{ $t('ct-select') }}</button>
    </sweet-modal>
  </div>
</template>
<script>
  import {getTags, getGroups} from '../../../js/services/editor/autotag';
  import {SweetModal, SweetModalTab} from 'sweet-modal-vue'

  export default {
    name: 'TextTagComponent',
    components: {
      SweetModal,
      SweetModalTab
    },
    data() {
      return {
        element: null,
        value: '',
        labelDesc: 'opa',
        callback: null,
        filter: '',
        tagSelected: '',
        position: '',
        tags: [],
        groups: [],
        tagList: [
          'tag_user_id',
          'tag_name',
          'tag_name_lead',
          'tag_last_name',
          'tag_skype',
          'tag_wechat',
          'tag_phone',
          'tag_whatsapp',
          'tag_address_type',
          'tag_address_postal_code',
          'tag_address_description',
          'tag_address_number',
          'tag_address_complement',
          'tag_address_district',
          'tag_address_city',
          'tag_address_state',
          'tag_facebook_profile',
          'tag_email',
          'tag_fullname',
          'tag_address_part1',
          'tag_address_part2',
          'extra_tag_0',
          'extra_tag_1',
          'extra_tag_2',
          'extra_tag_3',
          'extra_tag_4',
          'extra_tag_5',
          'extra_tag_6',
          'extra_tag_7',
          'extra_tag_8',
          'extra_tag_9',
          'extra_tag_10',
          'extra_tag_11',
          'extra_tag_12',
          'extra_tag_13',
          'extra_tag_14',
          'extra_tag_15',
          'extra_tag_16',
          'extra_tag_17',
          'extra_tag_18',
          'extra_tag_19',
        ]
      }
    },
    methods: {

      save() {
        this.callback(this.tagSelected);
        this.$refs.modal.close();
        this.$root.$emit('blurEvent', true);
      },

      close() {
        this.$refs.modal.close();
        this.$root.$emit('blurEvent', true);
      },

      focusTag(tag) {
        console.log(tag);
        $('.focused').removeClass('focused');

        $('.' + tag.replace('[','').replace(']','')).addClass('focused');
        this.tagSelected = tag;
      },
      showTagList() {
        let $body = $('body');
        $body.addClass('loading');

        $('.widget-focused').removeClass('widget-focused');

        this.$refs.modal.open();

        setTimeout(function () {
          $body.removeClass('loading');
        }, 2000);
      },
      getUserGroups() {
        let vm = this;
        getTags()
          .then((res) => {
            vm.tags = res.data;
            console.log(vm.tags);
          });
        getGroups()
          .then((res) => {
            vm.groups = res.data;
            console.log(vm.groups);
          });
      },
    },
    mounted() {
      let vm = this;
      this.$root.$on('showTagList', (callback) => {
        vm.callback = callback;
        vm.showTagList();
        vm.getUserGroups();
      });
    }
  }
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>
<style lang="scss">
  .item-tag {
    display: none;
    font-size: 12px;
    cursor: pointer;
    text-align: left;
    padding: 5px;
    border-radius: 5px;

    &.focused {
      border: 1px solid blue;
    }

  }

  .item-tag.show {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextTag.vue